import { cn } from "@/lib/utils";
import CTAButton from "../home/CTAButton";

type BasicBlockProps = {
  children: React.ReactNode;
  wrapperStyle?: string;
  contentStyle?: string;
  headerStyle?: string;
  header?: React.ReactNode | string;
  mobileHeader?: string;
  subHeader?: string;
  subHeaderStyle?: string;
  bgStyle?: string;
  customCTA?: { text: string; href: string };
};

const BasicBlock = ({
  children,
  wrapperStyle,
  contentStyle,
  headerStyle,
  header,
  mobileHeader,
  subHeader,
  subHeaderStyle,
  bgStyle,
  customCTA,
}: BasicBlockProps) => {
  return (
    <div className={cn("flex w-full items-center justify-center", bgStyle)}>
      <div
        className={cn(
          "mx-auto flex w-full max-w-screen-2xl flex-col gap-10 px-4 py-12 md:px-12 lg:px-[120px]",
          wrapperStyle,
        )}
      >
        {header && typeof header === "string" ? (
          <div className="flex w-full flex-wrap items-center justify-between gap-4">
            <h3
              className={cn(
                "flex flex-col gap-4 text-[38px] font-semibold leading-none md:text-[45px]",
                headerStyle,
              )}
            >
              {mobileHeader ? (
                <>
                  <span className="block md:hidden">{mobileHeader}</span>
                  <span className="hidden md:block">{header}</span>
                </>
              ) : (
                header
              )}
              {subHeader && (
                <span
                  className={cn(
                    "block text-[14px] font-medium text-[#616885] sm:text-[16px]",
                    subHeaderStyle,
                  )}
                >
                  {subHeader}
                </span>
              )}
            </h3>
            <CTAButton cta={customCTA} />
          </div>
        ) : (
          header
        )}
        <div className={cn("flex w-full", contentStyle)}>{children}</div>
      </div>
    </div>
  );
};

export default BasicBlock;
